import { AppSessionService } from "@shared/common/session/app-session.service";
import { PermissionCheckerService } from "abp-ng2-module";

import { Injectable } from "@angular/core";
import { AppMenu } from "./app-menu";
import { AppMenuItem } from "./app-menu-item";

@Injectable()
export class AppNavigationService {
    constructor(
        private readonly _permissionCheckerService: PermissionCheckerService,
        private readonly _appSessionService: AppSessionService,
    ) {}

    getMenu(): AppMenu {
        return new AppMenu("MainMenu", "MainMenu", [
            new AppMenuItem("Masters", "", "flaticon-map", "", [
                new AppMenuItem(
                    "Assets",
                    "FixedAssets.Masters.Assets",
                    "assets.svg",
                    "/app/main/assets",
                ),
                new AppMenuItem(
                    "Places",
                    "FixedAssets.Masters.Places",
                    "places.svg",
                    "/app/main/places",
                ),
                new AppMenuItem(
                    "Zones",
                    "FixedAssets.Masters.Zones",
                    "zones.svg",
                    "/app/main/zones",
                ),
                new AppMenuItem(
                    "Properties",
                    "FixedAssets.Masters.Properties",
                    "properties.svg",
                    "/app/main/properties",
                ),
                new AppMenuItem(
                    "Deposits",
                    "FixedAssets.Masters.Deposits",
                    "deposits.svg",
                    "/app/main/deposits",
                ),
                new AppMenuItem(
                    "Groups",
                    "FixedAssets.Masters.Groups",
                    "groups.svg",
                    "/app/main/groups",
                ),
                new AppMenuItem(
                    "Subgroups",
                    "FixedAssets.Masters.SubGroups",
                    "subgroups.svg",
                    "/app/main/subgroups",
                ),
            ]),

            new AppMenuItem("Activities", "", "flaticon-map", "", [
                new AppMenuItem(
                    "PurchaseProcesses",
                    "FixedAssets.Activities.PurchaseProcess",
                    "cart-purchase.svg",
                    "/app/main/purchase-processes",
                ),
                new AppMenuItem(
                    "Transferences",
                    "FixedAssets.Activities.Transference",
                    "transference.svg",
                    "/app/main/transferences",
                ),
                new AppMenuItem(
                    "QueryMovements",
                    "FixedAssets.Reporting",
                    "movements.svg",
                    "/app/main/movements",
                ),
            ]),

            new AppMenuItem("Auditing", "", "flaticon-clipboard", "", [
                new AppMenuItem(
                    "Synchronization",
                    "Pages.AssetAuditHistories.Sync",
                    null,
                    "/app/main/audit/synchronization",
                ),
                new AppMenuItem(
                    "Survey",
                    "Pages.AssetAuditHistories.Sync",
                    null,
                    "/app/main/audit/survey",
                ),
            ]),

            new AppMenuItem("Administration", "", "flaticon-interface-8", "", [
                new AppMenuItem(
                    "Users",
                    "Pages.Administration.Users",
                    null,
                    "/app/admin/users",
                ),
                new AppMenuItem(
                    "Languages",
                    "Pages.Administration.Languages",
                    null,
                    "/app/admin/languages",
                ),
                new AppMenuItem(
                    "Dashboard",
                    "Pages.Tenant.Dashboard",
                    null,
                    "/app/main/dashboard",
                ),
                new AppMenuItem(
                    "Dashboard",
                    "Pages.Administration.Host.Dashboard",
                    null,
                    "/app/admin/hostDashboard",
                ),
                new AppMenuItem(
                    "Tenants",
                    "Pages.Tenants",
                    null,
                    "/app/admin/tenants",
                ),
                new AppMenuItem(
                    "OrganizationUnits",
                    "Pages.Administration.OrganizationUnits",
                    null,
                    "/app/admin/organization-units",
                ),
                new AppMenuItem(
                    "Roles",
                    "Pages.Administration.Roles",
                    null,
                    "/app/admin/roles",
                ),
                new AppMenuItem(
                    "AuditLogs",
                    "Pages.Administration.AuditLogs",
                    null,
                    "/app/admin/auditLogs",
                ),
                new AppMenuItem(
                    "Maintenance",
                    "Pages.Administration.Host.Maintenance",
                    null,
                    "/app/admin/maintenance",
                ),
                new AppMenuItem(
                    "Settings",
                    "Pages.Administration.Host.Settings",
                    null,
                    "/app/admin/hostSettings",
                ),
                new AppMenuItem(
                    "Settings",
                    "Pages.Administration.Tenant.Settings",
                    null,
                    "/app/admin/tenantSettings",
                ),
            ]),
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (
                subMenuItem.permissionName === "" ||
                subMenuItem.permissionName === null ||
                (subMenuItem.permissionName &&
                    this._permissionCheckerService.isGranted(
                        subMenuItem.permissionName,
                    ))
            ) {
                return true;
            } else if (subMenuItem.items && subMenuItem.items.length) {
                return this.checkChildMenuItemPermission(subMenuItem);
            }
        }

        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (
            menuItem.permissionName &&
            !this._permissionCheckerService.isGranted(menuItem.permissionName)
        ) {
            hideMenuItem = true;
        }

        if (
            this._appSessionService.tenant ||
            !abp.multiTenancy.ignoreFeatureCheckForHostUsers
        ) {
            if (
                menuItem.hasFeatureDependency() &&
                !menuItem.featureDependencySatisfied()
            ) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach((menuItem) => {
            allMenuItems = allMenuItems.concat(
                this.getAllMenuItemsRecursive(menuItem),
            );
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach((subMenu) => {
            menuItems = menuItems.concat(
                this.getAllMenuItemsRecursive(subMenu),
            );
        });

        return menuItems;
    }
}
